import React, { useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { toast } from "react-hot-toast";
import { Tooltip, Button } from "antd";

function ExportReportsCSV({
  data,
  columns,
  accessLevel,
  isLoading,
  editedData,
  reportTitle,
  projectName,
}) {
  const [exportLoading, setExportLoading] = useState(false);

  const handleExportCSV = () => {
    try {
      setExportLoading(true);
      const toastId = toast.loading("Exporting CSV...");

      setTimeout(() => {
        // Step 1: Build formatted rows based on column order
        const exportColumns = columns.map((col) => ({
          header: typeof col.title === "object" ? "Status" : col.title,
          key: col.key,
        }));

        const formattedData = data.map((row) => {
          const formattedRow = {};
          exportColumns.forEach((col) => {
            formattedRow[col.header] = row[col.key] ?? "";
          });
          return formattedRow;
        });

        // Step 2: Convert to worksheet and CSV
        const worksheet = XLSX.utils.json_to_sheet(formattedData, {
          header: exportColumns.map((col) => col.header),
        });

        const csv = XLSX.utils.sheet_to_csv(worksheet);

        // Step 3: Create Blob and trigger download
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const filename = `${projectName} - ${reportTitle}.csv`;
        saveAs(blob, filename);

        toast.success("CSV exported successfully!", { id: toastId });
        setExportLoading(false);
      }, 0);
    } catch (error) {
      console.error("CSV export error:", error);
      toast.dismiss();
      toast.error("Error exporting CSV. Please try again.");
    }
  };

  return (
    <>
      {editedData.length > 0 ? (
        <Tooltip title="Please save changes before exporting.">
          <div>
            <Button
              color="default"
              variant="link"
              disabled={
                accessLevel < 2 ||
                isLoading ||
                exportLoading ||
                data.length < 1 ||
                editedData.length > 0
              }
              size="small"
              style={{
                justifyContent: "flex-start",
                display: "flex",
                alignItems: "center",
              }}
              onClick={handleExportCSV}
            >
              Export to CSV
            </Button>
          </div>
        </Tooltip>
      ) : (
        <Button
          color="default"
          variant="link"
          size="small"
          style={{
            justifyContent: "flex-start",
            display: "flex",
            alignItems: "center",
          }}
          disabled={
            accessLevel < 2 ||
            isLoading ||
            exportLoading ||
            data.length < 1 ||
            editedData.length > 0
          }
          onClick={handleExportCSV}
        >
          Export to CSV
        </Button>
      )}
    </>
  );
}

export default ExportReportsCSV;
